import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed bottom-4 right-4 bg-black px-8 py-6 grid gap-2 rounded-md shadow-lg z-50" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-sm" }, " Start with some Seed Data? ", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Add Seed Data ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Reset Data ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Hide Seeder ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_BaseButton, {
      class: "text-center bg-white text-black justify-center hover:bg-gray-300",
      onClick: _ctx.seedData
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_BaseButton, {
      class: "text-white justify-center hover:bg-gray-900",
      onClick: _ctx.resetData
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_BaseButton, {
      class: "text-white justify-center hover:bg-gray-900",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false))
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    })
  ], 512)), [
    [_vShow, _ctx.show]
  ])
}